import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mb-4" }
const _hoisted_6 = { class: "row g-3 pt-4" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "fw-semibold mb-0" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "fw-semibold mb-0" }
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = { class: "fw-semibold mb-0" }
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = { class: "fw-semibold mb-0" }
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = { class: "fw-semibold mb-0" }
const _hoisted_17 = { class: "row g-3 pt-4" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "fw-semibold mb-0" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "fw-semibold mb-0" }
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "fw-semibold mb-0" }
const _hoisted_24 = { class: "col-md-2" }
const _hoisted_25 = { class: "fw-semibold mb-0" }
const _hoisted_26 = { class: "col-md-2" }
const _hoisted_27 = { class: "fw-semibold mb-0" }
const _hoisted_28 = { class: "row g-3 pt-4" }
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = { class: "fw-semibold mb-0" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = { class: "fw-semibold mb-0" }
const _hoisted_33 = { class: "col-md-2" }
const _hoisted_34 = { class: "fw-semibold mb-0" }
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = { class: "fw-semibold mb-0" }
const _hoisted_37 = { class: "col-md-2" }
const _hoisted_38 = { class: "fw-semibold mb-0" }
const _hoisted_39 = { class: "row g-3 pt-4" }
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = { class: "fw-semibold mb-0" }
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = { class: "fw-semibold mb-0" }
const _hoisted_44 = { class: "col-md-2" }
const _hoisted_45 = { class: "fw-semibold mb-0" }
const _hoisted_46 = { class: "col-md-2" }
const _hoisted_47 = { class: "fw-semibold mb-0" }
const _hoisted_48 = { class: "col-md-2" }
const _hoisted_49 = { class: "fw-semibold mb-0" }
const _hoisted_50 = { class: "row g-3 pt-4" }
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = { class: "fw-semibold mb-0" }
const _hoisted_53 = { class: "col-md-3" }
const _hoisted_54 = { class: "fw-semibold mb-0" }
const _hoisted_55 = { class: "col-md-2" }
const _hoisted_56 = { class: "fw-semibold mb-0" }
const _hoisted_57 = { class: "col-md-2" }
const _hoisted_58 = { class: "fw-semibold mb-0" }
const _hoisted_59 = { class: "col-md-2" }
const _hoisted_60 = { class: "fw-semibold mb-0" }
const _hoisted_61 = { class: "row g-3 pt-4" }
const _hoisted_62 = { class: "col-md-3" }
const _hoisted_63 = { class: "fw-semibold mb-0" }
const _hoisted_64 = { class: "col-md-3" }
const _hoisted_65 = { class: "fw-semibold mb-0" }
const _hoisted_66 = { class: "col-md-2" }
const _hoisted_67 = { class: "fw-semibold mb-0" }
const _hoisted_68 = { class: "col-md-2" }
const _hoisted_69 = { class: "fw-semibold mb-0" }
const _hoisted_70 = {
  key: 0,
  class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25"
}
const _hoisted_71 = { class: "table table-hover" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  class: "modal fade",
  id: "marchandiseModal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "marchandiseModal"
}
const _hoisted_74 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_75 = { class: "modal-content shadow-lg border-0" }
const _hoisted_76 = { class: "modal-body p-4" }
const _hoisted_77 = { class: "card border-0 bg-light mb-4" }
const _hoisted_78 = { class: "card-body" }
const _hoisted_79 = { class: "row g-3" }
const _hoisted_80 = { class: "col-md-2" }
const _hoisted_81 = { class: "fw-semibold mb-0" }
const _hoisted_82 = { class: "col-md-2" }
const _hoisted_83 = { class: "fw-semibold mb-0" }
const _hoisted_84 = { class: "col-md-2" }
const _hoisted_85 = { class: "fw-semibold mb-0" }
const _hoisted_86 = { class: "col-md-2" }
const _hoisted_87 = { class: "fw-semibold mb-0" }
const _hoisted_88 = { class: "col-md-2" }
const _hoisted_89 = { class: "fw-semibold mb-0" }
const _hoisted_90 = { class: "col-md-2" }
const _hoisted_91 = { class: "fw-semibold mb-0" }
const _hoisted_92 = { class: "row g-3 mt-3" }
const _hoisted_93 = { class: "col-md-2" }
const _hoisted_94 = { class: "fw-semibold mb-0" }
const _hoisted_95 = { class: "col-md-2" }
const _hoisted_96 = { class: "fw-semibold mb-0" }
const _hoisted_97 = { class: "col-md-2" }
const _hoisted_98 = { class: "fw-semibold mb-0" }
const _hoisted_99 = { class: "col-md-2" }
const _hoisted_100 = { class: "fw-semibold mb-0" }
const _hoisted_101 = { class: "col-md-2" }
const _hoisted_102 = { class: "fw-semibold mb-0" }
const _hoisted_103 = { class: "col-md-2" }
const _hoisted_104 = { class: "fw-semibold mb-0" }
const _hoisted_105 = { class: "row g-3 mt-3" }
const _hoisted_106 = { class: "col-md-2" }
const _hoisted_107 = { class: "fw-semibold mb-0" }
const _hoisted_108 = { class: "col-md-2" }
const _hoisted_109 = { class: "fw-semibold mb-0" }
const _hoisted_110 = { class: "col-md-2" }
const _hoisted_111 = { class: "fw-semibold mb-0" }
const _hoisted_112 = { class: "col-md-2" }
const _hoisted_113 = { class: "fw-semibold mb-0" }
const _hoisted_114 = { class: "col-md-2" }
const _hoisted_115 = { class: "fw-semibold mb-0" }
const _hoisted_116 = { class: "modal-footer bg-light border-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "d-lg-flex align-items-center justify-content-between mb-3" }, [
                _createElementVNode("h4", { class: "position-relative text-primary fw-bold mb-0" }, "Détail du document")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[1] || (_cache[1] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Type", -1)),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.document?.type), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Arm", -1)),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.document?.arm), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Num", -1)),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.document?.num), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Sic", -1)),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.document?.sic), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Otc", -1)),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.document?.etd || 'N/A'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Refotc", -1)),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.document?.refotc || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Transit", -1)),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.document?.transit), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-muted small mb-1" }, "IdAtpTbt", -1)),
                  _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.document?.idAtpTbt || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-muted small mb-1" }, "RefArmTbt", -1)),
                  _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.document?.refArmTbt || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Pec", -1)),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.document?.pec || 'N/A'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-muted small mb-1" }, "PecLib", -1)),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.document?.pecLib || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-muted small mb-1" }, "First", -1)),
                  _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.document?.first), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-muted small mb-1" }, "FirstLib", -1)),
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.document?.firstLib), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Last", -1)),
                  _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.document?.last), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Last Lib", -1)),
                  _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.document?.lastLib), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Pod", -1)),
                  _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.document?.pod), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Pod Lib", -1)),
                  _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.document?.podLib), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Last pod", -1)),
                  _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.document?.lastpod), 1)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Fin", -1)),
                  _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.document?.fin), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Fin Lib", -1)),
                  _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.document?.finLib), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "text-muted small mb-1" }, "PaysDest", -1)),
                  _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.document?.paysDest || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Pays DestLib", -1)),
                  _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.document?.paysDestLib || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Shipper Code", -1)),
                  _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.document?.shipperCode || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Shipper Type", -1)),
                  _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.document?.shipperType || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Shipper Name", -1)),
                  _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.document?.shipperName || 'N/A'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Type Destinataire", -1)),
                  _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.document?.consigneeType || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Destinataire", -1)),
                  _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.document?.consigneeName || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code Notification", -1)),
                  _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.document?.notifyCode || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Notify Type", -1)),
                  _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.document?.notifyType || 'N/A'), 1)
                ])
              ])
            ]),
            (_ctx.cargoItems.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _cache[32] || (_cache[32] = _createElementVNode("h5", { class: "fw-bold mb-3 text-primary" }, "Marchandises", -1)),
                  _createElementVNode("table", _hoisted_71, [
                    _cache[31] || (_cache[31] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Code Lib"),
                        _createElementVNode("th", null, "Code SH"),
                        _createElementVNode("th", null, "ItemNumber"),
                        _createElementVNode("th", null, "Mrn"),
                        _createElementVNode("th", null, "Nb"),
                        _createElementVNode("th", null, "Poids"),
                        _createElementVNode("th", null, "Ref"),
                        _createElementVNode("th", null, "Actions")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cargoItems, (march, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(march.codeLib), 1),
                          _createElementVNode("td", null, _toDisplayString(march.codeSH), 1),
                          _createElementVNode("td", null, _toDisplayString(march.itemNumber), 1),
                          _createElementVNode("td", null, _toDisplayString(march.mrn), 1),
                          _createElementVNode("td", null, _toDisplayString(march.nb), 1),
                          _createElementVNode("td", null, _toDisplayString(march.poids), 1),
                          _createElementVNode("td", null, _toDisplayString(march.ref), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-primary",
                              onClick: ($event: any) => (_ctx.goToMarchDetail(march))
                            }, " Voir les détails ", 8, _hoisted_72)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_73, [
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _cache[50] || (_cache[50] = _createElementVNode("h6", { class: "text-primary fw-bold mb-3" }, [
                  _createElementVNode("i", { class: "bi bi-info-circle me-2" }),
                  _createTextVNode("Informations Marchandise ")
                ], -1)),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Sic", -1)),
                    _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.selectedMarchandise?.sic), 1)
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Ref", -1)),
                    _createElementVNode("p", _hoisted_83, _toDisplayString(_ctx.selectedMarchandise?.ref), 1)
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _cache[35] || (_cache[35] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Eqd", -1)),
                    _createElementVNode("p", _hoisted_85, _toDisplayString(_ctx.selectedMarchandise?.eqd || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Nb", -1)),
                    _createElementVNode("p", _hoisted_87, _toDisplayString(_ctx.selectedMarchandise?.nb || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code", -1)),
                    _createElementVNode("p", _hoisted_89, _toDisplayString(_ctx.selectedMarchandise?.code), 1)
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code Lib", -1)),
                    _createElementVNode("p", _hoisted_91, _toDisplayString(_ctx.selectedMarchandise?.codeLib || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Poids", -1)),
                    _createElementVNode("p", _hoisted_94, _toDisplayString(_ctx.selectedMarchandise?.poids || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Poids Net", -1)),
                    _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.selectedMarchandise?.poidsnet || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _cache[41] || (_cache[41] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Marques", -1)),
                    _createElementVNode("p", _hoisted_98, _toDisplayString(_ctx.selectedMarchandise?.marques || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Mrn", -1)),
                    _createElementVNode("p", _hoisted_100, _toDisplayString(_ctx.selectedMarchandise?.mrn), 1)
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _cache[43] || (_cache[43] = _createElementVNode("label", { class: "text-muted small mb-1" }, "StatComm", -1)),
                    _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.selectedMarchandise?.statComm), 1)
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Item Number", -1)),
                    _createElementVNode("p", _hoisted_104, _toDisplayString(_ctx.selectedMarchandise?.itemNumber || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("div", _hoisted_106, [
                    _cache[45] || (_cache[45] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code SH", -1)),
                    _createElementVNode("p", _hoisted_107, _toDisplayString(_ctx.selectedMarchandise?.codeSH || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _cache[46] || (_cache[46] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Zone", -1)),
                    _createElementVNode("p", _hoisted_109, _toDisplayString(_ctx.selectedMarchandise?.zone || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_110, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Zone Lib", -1)),
                    _createElementVNode("p", _hoisted_111, _toDisplayString(_ctx.selectedMarchandise?.zoneLib || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _cache[48] || (_cache[48] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Lieu", -1)),
                    _createElementVNode("p", _hoisted_113, _toDisplayString(_ctx.selectedMarchandise?.lieu || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Lieu Lib", -1)),
                    _createElementVNode("p", _hoisted_115, _toDisplayString(_ctx.selectedMarchandise?.lieuLib || 'N/A'), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal2 && _ctx.closeModal2(...args)))
            }, [...(_cache[51] || (_cache[51] = [
              _createElementVNode("i", { class: "bi bi-x-circle me-2" }, null, -1),
              _createTextVNode("Fermer ", -1)
            ]))])
          ])
        ])
      ])
    ], 512)
  ], 64))
}